// Accesos recientes del Command Palette — persistidos por usuario en localStorage.
const KEY = (email) => `valoriza-recents-${email || "anon"}`;
const MAX = 8;

export function getRecents(email) {
  try { return JSON.parse(localStorage.getItem(KEY(email))) || []; } catch { return []; }
}

export function pushRecent(email, entry) {
  // entry: { path, title, sub?, type }
  if (!entry?.path || !entry?.title) return;
  const list = getRecents(email).filter((r) => !(r.path === entry.path && r.title === entry.title));
  list.unshift({ ...entry, ts: Date.now() });
  try { localStorage.setItem(KEY(email), JSON.stringify(list.slice(0, MAX))); } catch {}
}
